import React, { Component } from 'react';
import AppRouter from './AppRouter';

class App extends Component {
  render() {
    return (
      <AppRouter />
    );
  }
}

export default App;



// WEBPACK FOOTER //
// ./src/components/App.js